module.exports.getConfig = function ()
{
    return {
        version: "50.16.2",
        environment: 'local',

        integrationServer: 'http://localhost:5191/api',
        gatewayServer: 'http://localhost:5191/api',
        webOrderingGateway: "integrations/webApp/versions/3.0",
        webOrderingGatewayTokenId: 'K4JUtNRQWE+oicQCLumhYw==',
        appUrlWebOrdering: 'http://localhost:3191',
        cdnAppCloudName: 'rms-jinoby',
        webOrderingLocalStorageEnabled: false,
        webOrderingLocalStorageVersion: "1.0",
        rmsImgixCDNServerUrl: 'https://flipdish-rms-dev.imgix.net',

        webOrderingMinimumApiResultWaitTimeInMs: 500,
        webOrderingMinimumApiReAttemptWaitTimeInMs: 1000,
        webOrderingMinimumNoOfAttemptsForApi: 10,

        webOrderingExpiryForCachedUserPhoneNumber: 10080,      //7 days
        webOrderingExpiryForCachedPreviousOrdersInMinutes: 10080,      //7 days

        dataDogClientToken: 'pubaf4145b736da8f2456f5b1c830be1538',
        dataDogSite: 'us3.datadoghq.com',

        rmsFrontendSplitIoApiKey: "iqm68pjp7mbib2ehsbeo75cd4s6bo80agpvh",
    }
}
